export default __webpack_public_path__ + "static/1316-f1b79788a014d3cff9d0a39494c38003.gif";